import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline' | 'ghost' | 'secondary' | 'destructive';
  size?: 'default' | 'sm' | 'lg' | 'icon' | 'kiosk';
}
const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'default',
  size = 'default',
  ...props
}, ref) => {
  return <button ref={ref} className={cn('inline-flex items-center justify-center whitespace-nowrap rounded-xl text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', {
    'bg-brand-coral text-white hover:bg-brand-coral/90': variant === 'default',
    'bg-destructive text-destructive-foreground hover:bg-destructive/90': variant === 'destructive',
    'border border-input bg-background hover:bg-accent hover:text-accent-foreground': variant === 'outline',
    'bg-secondary text-secondary-foreground hover:bg-secondary/80': variant === 'secondary',
    'hover:bg-accent hover:text-accent-foreground': variant === 'ghost',
    'h-10 px-4 py-2': size === 'default',
    'h-9 rounded-lg px-3': size === 'sm',
    'h-12 rounded-xl px-8 text-base': size === 'lg',
    'h-14 rounded-2xl px-10 text-lg font-semibold': size === 'kiosk',
    'h-10 w-10': size === 'icon'
  }, className)} {...props} data-id="element-93" />;
});
Button.displayName = 'Button';
export { Button };